/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
*   Amina Rais - Massive Improvements
 * Version: 2.0.0
 *
 *******************************************************************************/

import React from 'react'
import { ToastContainer } from 'react-toastify'
import './App.css'
import Pages from './pages'
import 'react-toastify/dist/ReactToastify.css';

class App extends React.Component {
 

  render() {
    return (
      <div className="main">
        <ToastContainer />
        <Pages />
      </div>
    );
  }
}

export default App;
